<template>
    <div id="app">
        <div class="admin_main_block_top">
            <div class="admin_main_block_left">
                <el-select v-model="where.mend" placeholder="请选择门店" @change="selectChange()">
                    <el-option label="请选择门店" :value="0"></el-option>
                    <el-option v-for="(v,k) in mendlist" :label="v.F_VR_MINGC" :key="k" :value="v.F_IN_ID"></el-option>
                </el-select>
            </div>
        </div>
        <div class="calender-class">
            <!--<p>当前显示的月份：{{ formattedDate }}</p>-->
            <el-calendar v-model="value" @change="handleChange">
                <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
                <template slot="dateCell" slot-scope="{ date, data }">
                    <div class="day-content-class">
                        <template v-if="viewDate[data.day]">
                            <div class="header-class">
                                <div class="day-class">
                                    {{
                                    data.day
                                    .split("-")
                                    .slice(1)
                                    .join("-")
                                    }}
                                </div>
                                <div class="handle-class">
                                    <el-button icon="el-icon-edit" size="mini" circle
                                               @click="handleWorkInfo(viewDate[data.day], data)">
                                    </el-button>
                                </div>
                            </div>
                            <div class="paiban-class">
                                <div v-for="(dayValue, i) in viewDate[data.day]" :class="[
                    'draggable-div' + i,
                    'each-paiban-class',
                    setWorkClass(dayValue.sort),
                  ]" draggable="true" @dragstart="handleDragStart($event, dayValue, data.day)"
                                     @dragover.prevent="handleDragOver($event)"
                                     @dragenter="handleDragEnter($event, dayValue)"
                                     @dragend="handleDragEnd()">
                                    <i :class="[
                      setIconClass(dayValue.shiftName),
                      'paiban-icon-class',
                    ]"></i>
                                    <div class="paiban-name-class">{{ dayValue.huls }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="header-class">
                                <div class="day-class">
                                    {{
                                    data.day
                                    .split("-")
                                    .slice(1)
                                    .join("-")
                                    }}
                                </div>
                                <div class="handle-class">
                                    <el-button icon="el-icon-edit" size="mini" circle
                                               @click="handleWorkInfo(viewDate[data.day], data)">
                                    </el-button>
                                </div>
                            </div>
                            <div class="no-work-class">
                                <div class="icon-class"><i class="el-icon-date"></i></div>
                                <div class="tips-class">
                                    暂无排班
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </el-calendar>
        </div>

        <!-- 单独排班 -->
        <div>
            <el-drawer :title="'【' + hanleDay.day + '】排班'" :visible.sync="drawer" size="40%">
                <div class="add-work-class">
                    <el-button class="add-btn-class" type="primary" @click="innerDrawer = true">添加</el-button>
                    <el-drawer title="添加排班" :append-to-body="true" :before-close="handleClose"
                               :visible.sync="innerDrawer">
                        <div class="demo-drawer__content">

                            <div class="content">
                                <div class="selectAll">
                                    <div :class="['select',SelectId.length==CheckList.length?'selectActv':'']"
                                         @click="allFun()"></div>
                                    <span>全选/反选</span>
                                </div>
                                <div class="CheckBox">
                                    <div class="CheckItem" v-for="(item,index) in CheckList" :key="index">
                                        <div :class="['select',SelectId.includes(item.id)?'selectActv':'']"
                                             @click="selectFun(item.id)"></div>
                                        <span>{{item.text}}</span>
                                    </div>
                                </div>
                                <!--<div>已选项：</div>
                                <p v-for="(item,index) in ChooseList" :key="index">
                                    {{item}}
                                </p>-->
                                <el-form :model="addForm">
                                    <el-form-item label="护理师：" label-width="">
                                        <el-radio-group v-model="addForm.groupName">
                                            <el-radio v-for="item in hulslist" :key="item.F_IN_ID"
                                                      :label="item.F_VR_XINGM"
                                            >{{ item.F_VR_XINGM }}
                                            </el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div class="demo-drawer__footer" style="margin-left:20px;margin-top:60px;">
                            <el-button @click="handleClose">取 消</el-button>
                            <el-button type="primary" @click="addWork()">
                                确定
                            </el-button>
                        </div>
                    </el-drawer>
                </div>
                <el-table :data="workInfoList">
                    <el-table-column property="riq" label="日期" width="90"></el-table-column>
                    <el-table-column property="shij" label="班次" width="80"></el-table-column>
                    <el-table-column property="huls" label="护理师"></el-table-column>
                    <el-table-column property="kehnc" label="客户昵称" ></el-table-column>
                    <el-table-column property="kehshoujh" label="客户手机号"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="deleteRow(scope, workInfoList)" type="text" size="small">
                                移除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-drawer>
        </div>

    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                SelectId: [], // 已选列表
                CheckList: [
                    {id: 1, text: "08:00:00"},
                    {id: 2, text: "08:45:00"},
                    {id: 3, text: "09:30:00"},
                    {id: 4, text: "10:15:00"},
                    {id: 5, text: "11:00:00"},
                    {id: 6, text: "11:45:00"},
                    {id: 7, text: "12:30:00"},
                    {id: 8, text: "13:15:00"},
                    {id: 9, text: "14:00:00"},
                    {id: 10, text: "14:45:00"},
                    {id: 11, text: "15:30:00"},
                    {id: 12, text: "16:15:00"},
                    {id: 13, text: "17:00:00"},
                    {id: 14, text: "17:45:00"},
                    {id: 15, text: "18:30:00"},
                    {id: 16, text: "19:15:00"},
                    {id: 17, text: "20:00:00"},
                    {id: 18, text: "20:45:00"},
                    {id: 19, text: "21:30:00"},
                    {id: 20, text: "22:15:00"},
                ],
                info: {
                    mendid: 0,
                    paib: '',
                    yuef: '',
                    riq: ''
                },
                mendlist: [],
                hulslist: [],
                where: {
                    mend: '',
                    yuef: ''
                },
                viewDate: {
                    /*"2024-01-01": [{
                            mendid: 1,
                            yuef: "2023-10",
                            riq: "2023-10-08",
                            shij: "08:30:00",
                            startTime: "2023-10-08 08:30:00",
                            huls: "",
                            disable: false,
                            kehid:0,
                            kehshoujh: "",
                            kehnc: "",
                        },
                        {
                            mendid: 1,
                            yuef: "2023-10",
                            riq: "2023-10-08",
                            shij: "08:30:00",
                            startTime: "2023-10-08 08:30:00",
                            huls: "",
                            disable: false,
                            kehid:0,
                            kehshoujh: "",
                            kehnc: "",
                        }
                    ],
                    "2024-01-02": [{
                            mendid: 1,
                            yuef: "2023-10",
                            riq: "2023-10-08",
                            shij: "08:30:00",
                            startTime: "2023-10-08 08:30:00",
                            huls: "",
                            disable: false,
                            kehid:0,
                            kehshoujh: "",
                            kehnc: "",
                        }
                    ],*/
                },
                thisDay: null,
                thisDayWork: null,
                ending: null,
                dragging: null,

                batchAddDrawer: false,
                // 批量添加
                batchAddForm: {
                    batchDate: [],
                    classData: [{
                        shiftName: "早",
                        groupName: "甲",
                    },],
                },
                // 单日添加
                addForm: {
                    shiftName: "早",
                    groupName: "甲",
                    sort: 1,
                },
                drawer: false,
                innerDrawer: false,
                hanleDay: "",
                workInfoList: [],

                // 时间范围
                dateRange: ['2023-10-1', '2023-10-20'],
                changeDateDrawer: false,
                // 点击月中已选中的日期
                currentDate: [],
                currentMonth: '',
                date: new Date(), // 默认选中今天
                value: new Date(),
                formattedDate: ''
            };
        },
        watch: {
            "addForm.shiftName"(newVal, oldVal) {
                switch (newVal) {
                    case "1":
                        this.addForm.sort = 1;
                        break;
                    case "2":
                        this.addForm.sort = 2;
                        break;
                    case "3":
                        this.addForm.sort = 3;
                        break;
                    case "4":
                        this.addForm.sort = 4;
                        break;
                    case "5":
                        this.addForm.sort = 5;
                        break;
                    case "6":
                        this.addForm.sort = 6;
                        break;
                    case "7":
                        this.addForm.sort = 7;
                        break;
                    case "8":
                        this.addForm.sort = 8;
                        break;
                    case "9":
                        this.addForm.sort = 9;
                        break;
                    case "10":
                        this.addForm.sort = 10;
                        break;
                    case "11":
                        this.addForm.sort = 11;
                        break;
                    case "12":
                        this.addForm.sort = 12;
                        break;
                    case "13":
                        this.addForm.sort = 13;
                        break;
                    case "14":
                        this.addForm.sort = 14;
                        break;
                    case "15":
                        this.addForm.sort = 15;
                        break;
                    case "16":
                        this.addForm.sort = 16;
                        break;
                    case "17":
                        this.addForm.sort = 17;
                        break;
                    case "18":
                        this.addForm.sort = 18;
                        break;
                    case "19":
                        this.addForm.sort = 19;
                        break;
                    case "20":
                        this.addForm.sort = 20;
                        break;
                    default:
                        break;
                }
            },
        },
        computed: {
            // 被选中项的集合
            ChooseList() {
                return this.CheckList.filter((item) => {
                    if (this.SelectId.includes(item.id)) {
                        return item
                    }
                })
            },
        },
        created() {
            this.formattedDate = this.getCurrentDate();
            this.where.yuef =  this.formattedDate;
            this.$nextTick(() => {
                // 点击前一个月
                let prevBtn = document.querySelector(
                    ".el-calendar__button-group .el-button-group>button:nth-child(1)"
                );
                prevBtn.addEventListener("click", e => {
                    console.log(this.value);
                    const now = new Date().toLocaleString('zh-CN', {timeZone: 'Asia/Shanghai'});
                    const currentMoment = moment(this.value);
                    //this.formattedDate = currentMoment.format('YYYY-MM-DD');
                    this.formattedDate = currentMoment.format('YYYY-MM');
                    this.where.yuef =  currentMoment.format('YYYY-MM');
                    /*this.$notify({
                        title: "上一月",
                        message: "上个月头天：" + this.formattedDate,
                        type: "success",
                        position: "top-left"
                    });*/
                });

                //点击下一个月
                let nextBtn = document.querySelector(
                    ".el-calendar__button-group .el-button-group>button:nth-child(3)"
                );
                nextBtn.addEventListener("click", () => {
                    console.log(this.value);
                    const now = new Date().toLocaleString('zh-CN', {timeZone: 'Asia/Shanghai'});
                    const currentMoment = moment(this.value);
                    this.formattedDate = currentMoment.format('YYYY-MM');
                    this.where.yuef =  currentMoment.format('YYYY-MM');
                    /*this.$notify({
                        title: "下一月",
                        message: "下个月头天：" + this.formattedDate,
                        type: "warning",
                        position: "top-left"
                    });*/
                });

                //点击今天
                let todayBtn = document.querySelector(
                    ".el-calendar__button-group .el-button-group>button:nth-child(2)"
                );
                todayBtn.addEventListener("click", () => {
                    console.log(this.value);
                    const now = new Date().toLocaleString('zh-CN', {timeZone: 'Asia/Shanghai'});
                    const currentMoment = moment(this.value);
                    this.formattedDate = currentMoment.format('YYYY-MM');
                    this.where.yuef =  currentMoment.format('YYYY-MM');
                    /*this.$notify.info({
                        title: "今天",
                        message: "今天：" + this.formattedDate,
                        position: "top-left"
                    });*/
                });

            });
            this.get_adv_list();
        },
        methods: {
            //获取当前年月
            getCurrentDate() {
                // 创建一个新的日期对象
                var date = new Date();
                // 设置时区为东八区（北京）
                date.setTime(date.getTime() + (8 * 60 * 60 * 1000)); // 将时间加上8小时

                // 格式化输出年、月、日、时、分、秒
                var year = date.getFullYear();
                var month = ("0" + (date.getMonth() + 1)).slice(-2);
                // 组合成完整的时间字符串
                return `${year}-${month}`;
            },
            handleChange(value) {
                this.currentMonth = value.getFullYear() + '-' + (value.getMonth() + 1);
            },
            selectFun(id) {
                if (!this.SelectId.includes(id)) {
                    this.SelectId.push(id) // 判断已选列表中是否存在该id，不是则追加进去
                } else {
                    let index = this.SelectId.indexOf(id) // 求出当前id的所在位置
                    this.SelectId.splice(index, 1) // 否则则删除
                }
            },
            // 全选、反选
            allFun() {
                if (this.SelectId.length == this.CheckList.length) {
                    this.SelectId = [] // 判断是否已全部选中，是则清空已选列表
                } else {
                    this.CheckList.forEach((item) => {
                        if (!this.SelectId.includes(item.id)) {
                            this.SelectId.push(item.id) // 否则将未选中的全部加入已选列表中
                        }
                    })
                }
            },
            get_adv_list: function () {
                console.log('获取当前月份')
                console.log(this.hanleDay)
                console.log('获取当前月份')

                /*this.where.page = this.current_page;*/
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                this.$get(this.$api.getHulsList, where).then(res => {
                    this.mendlist = res.data.mend;
                    this.hulslist = res.data.huls;
                    if (res.data.paib) {
                        if (res.data.paibinfo) {
                            this.viewDate = res.data.paibinfo;
                        }
                    } else {
                        this.viewDate = {};
                    }
                    console.log('门店')
                    console.log(this.list)
                    console.log('门店')
                    /*this.page_size = res.data.info.per_page;
                    this.total_data = res.data.info.total;
                    this.current_page = res.data.info.current_page;*/
                })
            },
            selectChange: function (e) {
                console.log('66666666' + this.where.mend + '6666666666')
                this.info.mendid = e;
                this.get_adv_list()
            },
            handleDragStart(e, item, thisDay) {
                this.dragging = item;
                this.thisDay = thisDay;
                this.thisDayWork = this.viewDate[thisDay];
            },
            handleDragEnd() {
                if (this.ending.id === this.dragging.id) {
                    return;
                }
                let newItems = [...this.thisDayWork];
                const src = newItems.indexOf(this.dragging);
                const dst = newItems.indexOf(this.ending);
                newItems.splice(src, 1, ...newItems.splice(dst, 1, newItems[src]));
                this.$set(this.viewDate, this.thisDay, newItems);
                this.$nextTick(() => {
                    this.dragging = null;
                    this.ending = null;
                });
                console.log(
                    "🚀 ~ file: App.vue:286 ~ handleDragEnd ~ this.viewDate:",
                    this.viewDate
                );
            },
            handleDragOver(e) {
                // 首先把div变成可以放置的元素，即重写dragenter/dragover
                e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
            },
            handleDragEnter(e, item) {
                e.dataTransfer.effectAllowed = "move"; // 为需要移动的元素设置dragstart事件
                this.ending = item;
            },
            setWorkClass(value) {
                let classValue = "zao-work-class";
                switch (value) {
                    case 1:
                        classValue = "zao-work-class";
                        break;
                    case 2:
                        classValue = "zao-work-class";
                        break;
                    case 3:
                        classValue = "zao-work-class";
                        break;
                    default:
                        break;
                }
                return classValue;
            },
            setIconClass(value) {
                let classValue = "el-icon-sunrise-1";
                switch (value) {
                    case "早":
                        classValue = "el-icon-sunrise-1";
                        break;
                    case "中":
                        classValue = "el-icon-sunny";
                        break;
                    case "晚":
                        classValue = "el-icon-moon";
                        break;
                    default:
                        break;
                }
                return classValue;
            },
            // 编辑单日排班
            handleWorkInfo(info, data) {

                console.log('编辑单独排班')
                console.log(info)
                console.log(data)
                console.log(data.day)
                console.log('编辑单独排班')

                var date = new Date(data.day); // 创建Date对象并传入日期字符串作为参数
                var year = date.getFullYear(); // 获取年份
                var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 获取月份并补零处理
                var yuef = `${year}-${month}`;
                console.log('月份月份月份月份')
                console.log(yuef)
                console.log('月份月份月份月份')

                this.info.yuef = yuef;
                this.info.riq = data.day;


                this.hanleDay = data;
                this.drawer = true;
                if (info && info.length > 0) {
                    this.workInfoList = info;
                } else {
                    this.workInfoList = [];
                }
            },
            handleClose() {
                console.log('关闭')
                this.innerDrawer = false;
            },
            // 添加单日排班
            addWork() {
                console.log('已选择已选择已选择已选择已选择')
                console.log(this.ChooseList)
                // 使用for循环遍历JSON对象数组
                for (var i = 0; i < this.ChooseList.length; i++) {
                    var obj = this.ChooseList[i]; // 获取当前元素的值（JSON对象）
                    console.log("ID：" + obj["id"]); // 输出名字属性的值
                    console.log("时间：" + obj["text"]);   // 输出年龄属性的值
                    console.log('111111111111111111')
                    this.addForm.shiftName = parseInt(this.addForm.shiftName);
                    console.log('111111111111111111')
                    let info = {
                        mendid: this.where.mend,
                        yuef: this.info.yuef,
                        riq: this.hanleDay.day,
                        shij: obj["text"],
                        startTime: this.hanleDay.day + " " + obj["text"],
                        huls: this.addForm.groupName,
                        disable: false,
                        kehid: 0,
                        kehshoujh: '',
                        kehnc: ''
                    };
                    this.workInfoList.push(info);
                }
                console.log('已选择已选择已选择已选择已选择')
                this.$set(this.viewDate, this.hanleDay.day, this.workInfoList);
                this.innerDrawer = false;
                console.log('排班信息')
                console.log(this.workInfoList)
                console.log(this.viewDate)
                console.log('排班信息')
                this.info.mendid = this.where.mend;
                this.info.paib = this.workInfoList;
                let _this = this;
                let url = _this.$api.addHuls;
                // Http 请求
                _this.$post(url, _this.info).then(function (res) {
                    if (res.code == 200) {
                        _this.innerDrawer = false;
                        _this.drawer = false;
                        _this.workInfoList = [];
                        _this.info.paib = [];
                        _this.viewDate = [];
                        _this.get_adv_list()

                        _this.$message.success("排班成功");
                    } else {
                        _this.$message.error("排班失败");
                    }
                });
            },
            // 清除单日排班数据
            deleteRow(row, tableData) {

                console.log('移除移除')
                console.log(row)
                console.log(tableData)
                console.log('移除移除')


                this.info.mendid = row.row.mendid;
                this.info.yuef = row.row.yuef;
                this.info.riq = row.row.riq;
                this.info.shij = row.row.shij;
                this.info.index = row.$index;

                let _this = this;
                let url = _this.$api.delHuls;
                // Http 请求
                _this.$post(url, _this.info).then(function (res) {
                    if (res.code == 200) {
                        _this.innerDrawer = false;
                        _this.drawer = false;
                        _this.workInfoList = [];
                        _this.info.paib = [];
                        _this.viewDate = [];
                        _this.get_adv_list()
                        _this.$message.success("排班成功");
                    } else {
                        _this.$message.error("排班失败");
                    }
                });
            }

        },
    };
</script>

<style>
    #app {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .el-table__fixed-right {
        height: 100% !important;
    }

    .calender-class {
        width: 100%;
        height: 100%;
    }

    .is-selected {
        color: #1989fa;
    }

    .el-calendar__body {
        height: 85vh;
    }

    .el-calendar-table {
        height: 100%;
    }

    .el-calendar-day {
        height: 100% !important;
    }

    .day-content-class {
        height: 100px;
        display: flex;
        flex-direction: column;
    }

    .header-class {
        flex: 1;
        display: flex;
        height: 28px;
        flex-direction: row;
        justify-content: space-between;
    }

    .day-class {
        flex: 4;
    }

    .handle-class {
        flex: 1;
    }

    .paiban-class {
        flex: 4;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
        overflow: hidden;
    }

    .paiban-icon-class {
        font-size: 22px;
        margin: 8px 0 10px 0;
    }

    .paiban-name-class {
        padding-top: 10px;
    }

    .each-paiban-class {
        text-align: center;
        max-width: 50px;
        margin: 5px 5px 0 5px;
        border-radius: 5px;
        padding: 0 0 5px 0;
        flex: 1;
    }

    .zao-work-class {
        background-color: #d9ffd9;
        color: #11be11;
    }

    .wan-work-class {
        background-color: #fff0bd;
        color: #fccb2c;
    }

    .ye-work-class {
        background-color: #ddeffb;
        color: #2dabff;
    }

    .no-work-class {
        text-align: center;
        color: #cacaca;
    }

    .icon-class {
        font-size: 20px;
        margin-bottom: 20px;
    }

    /* 侧边弹窗 */
    .add-btn-class {
        margin: 10px;
        float: right;
    }

    .change-date-drawer-class .el-calendar__body {
        height: 45%;
    }

    .change-date-drawer-class .day-content-class {
        height: 30px
    }

    .disabled-date-class {
        color: #ccc;
        pointer-events: none;
    }

    * {
        box-sizing: border-box;
        user-select: none;
    }

    .CheckBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 50px auto;
        margin-bottom: 20px;
    }

    .CheckItem {
        display: flex;
        margin: 0px 30px 30px 0px;
        align-items: center;
    }

    .select {
        width: 20px;
        height: 20px;
        border-radius: 2px;
        border: 1px solid #ccc;
        display: flex;
        justify-content: center;
        cursor: pointer;
        margin-right: 10px;
        align-items: center;
    }

    .selectActv::before {
        display: block;
        content: "";
        width: 5px;
        height: 12px;
        border-bottom: 2px solid #409eff;
        border-right: 2px solid #409eff;
        transform: rotate(45deg);
    }

    .selectAll {
        display: flex;
    }

    .content {
        /* width: 500px;*/
        margin: auto 20px;
    }
</style>
